// src/admin/components/SectionHead.tsx — repeating screen header pattern:
// eyebrow + title + description on the left, optional action on the right.
import type { ReactNode } from 'react';
import styles from './SectionHead.module.css';

interface Props {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export default function SectionHead({ eyebrow, title, description, action }: Props) {
  return (
    <div className={styles.head}>
      <div className={styles.left}>
        {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
        <h2 className={styles.title}>{title}</h2>
        {description && <p className={styles.desc}>{description}</p>}
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
